<template>
  <WrapperForm
    v-model="selectedTab"
    :tabs="tabs"
    :show-stepper="false"
    :tabs-placement="tabsPlacement"
  >
    <router-view />
  </WrapperForm>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import type { RouteName } from '@/router/route-name'
  import { useNavigationTabs } from '@/features/interface/profil-utilisateur/sections/useProfilUtilisateurNavigation'

  withDefaults(defineProps<{ tabsPlacement?: 'center' | 'start' }>(), { tabsPlacement: 'center' })

  const route = useRoute()
  const { tabs, goToTab, getTabsTitle } = useNavigationTabs()

  const selectedTab = computed({
    get: () => getTabsTitle(route.name as RouteName) ?? tabs.value[0]?.tabKey ?? '',
    set: (value: string) => goToTab(value),
  })
</script>
